import React, { useEffect, useRef, useState } from 'react';
import { LoadingIndicator, LoadingSkeleton } from '#lib/components/loading.jsx';
import { addClasses, cn } from '#lib/helpers/class.js';
import { convertStyles } from '#routes/manage/profiles/helpers.jsx';
import { Icon } from '@iconify-icon/react';
import Button from '#lib/components/button.jsx';
import { Link } from 'react-router-dom';

export default function IframePreview(props) {
    const { itinerary, options, show, src, ...rest } = props;
    const themeExists = options?.styles?.themeId;
    const [isIframeReady, setIsIframeReady] = useState(false);
    const [loading, setLoading] = useState(true);

    // copy default styles from theme selected
    const updated = {};

    if (options) {
        // for each property, if it exists, add or replace in updated obj
        if (options.styles?.colors?.primary) updated.primary = options?.styles?.colors?.primary;
        if (options.styles?.colors?.neutral) updated.neutral = options?.styles?.colors?.neutral;
    }
    const newStyles = { themeId: options?.styles?.themeId, colors: convertStyles(updated) };
    const newOptions = { ...options, styles: newStyles };

    const iframeRef = useRef(null);

    const handleIframeLoad = (e) => {
        setLoading(false);
    };

    const postMessage = (e) => {
        const iframe = iframeRef.current;
        if (!itinerary.language) itinerary.language = 'en';
        iframe?.contentWindow.postMessage(
            {
                type: 'set-itinerary',
                payload: { id: itinerary.id, itinerary, options: newOptions, places: itinerary.places || [] }
            },
            '*'
        );
    };

    const onMessage = (event) => {
        const { type, payload } = event.data;
        if (type === 'preview-state' && payload === 'ready') {
            setIsIframeReady(true);
            postMessage();
        }
    };

    useEffect(() => {
        window.addEventListener('message', onMessage);
        return () => {
            window.removeEventListener('message', onMessage);
        };
    });

    useEffect(() => {
        if (isIframeReady) {
            postMessage();
        }
    }, [isIframeReady, updated, options, itinerary]);

    if (!themeExists && !loading) {
        if (!show) return null;
        return (
            <div className="flex flex-col items-center justify-center w-full h-full gap-8 bg-neutral-100 text-neutral-600">
                <Icon icon="nonicons:error-16" width="4rem" height="4rem" />
                <Link to="/manage/profiles" className="text-neutral-500">
                    <Button size="xl" look="white" className={addClasses('flex flex-col gap-1 items-center')}>
                        <p className={cn('w-full text-center transition-all', show ? 'opacity-100' : 'opacity-0')}>
                            {_t.components.iframe.createProfile()}
                        </p>
                    </Button>
                </Link>
            </div>
        );
    }

    return (
        <>
            {loading && show && (
                <div className="absolute top-0 left-0 w-full h-full bg-white">
                    <LoadingIndicator
                        className={addClasses(
                            'z-10 absolute bg-white top-0 left-0 w-full h-full justify-center items-center'
                        )}
                    />
                    <LoadingSkeleton
                        className={addClasses(
                            'absolute bg-white top-0 left-0 w-full h-full justify-center items-center'
                        )}
                    />
                </div>
            )}
            <iframe
                ref={iframeRef}
                src={src}
                onLoad={handleIframeLoad}
                allow="autoplay; clipboard-write; web-share"
                {...rest}
            />
        </>
    );
}
